import { render } from "./elemTextarea.vue?vue&type=template&id=0b342cb2"
import script from "./elemTextarea.vue?vue&type=script&lang=js"
export * from "./elemTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__